/* Original, local-only search. No telemetry, fetch, cookies or personal data. */
(function(root){
  'use strict';
  const normalize=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  function matches(record,filters){
    const words=normalize(filters.query).split(/\s+/).filter(Boolean);
    return words.every(word=>normalize(record.search).includes(word)) &&
      (!filters.type || record.types.split(',').includes(filters.type)) &&
      (!filters.reg || record.reg===filters.reg);
  }
  const knowledgeMatches=(record,filters)=>normalize(filters.query).split(/\s+/).filter(Boolean).every(word=>normalize(record.search).includes(word)) && (!filters.kind||record.kind===filters.kind);
  if(typeof module==='object'&&module.exports)module.exports={normalize,matches,knowledgeMatches};
  if(!root.document)return;
  function init(scope){
    scope.querySelectorAll('[data-science-library]').forEach(library=>{
      if(library.dataset.initialized)return;
      library.dataset.initialized='true';
      const query=library.querySelector('#science-query'),type=library.querySelector('#science-type'),reg=library.querySelector('#science-reg');
      const cards=[...library.querySelectorAll('[data-science-card]')];
      const studies=[...library.querySelectorAll('[data-science-study]')];
      const update=()=>{
        let count=0;
        cards.forEach(card=>{card.hidden=!matches(card.dataset,{query:query.value,type:type.value,reg:reg.value});if(!card.hidden)count++;});
        library.querySelector('[data-science-count]').textContent=library.dataset.found+': '+count;
        library.querySelector('[data-science-empty]').hidden=count!==0;
        studies.forEach(study=>study.hidden=!matches(study.dataset,{query:query.value,type:type.value,reg:reg.value}));
      };
      [query,type,reg].forEach(input=>input.addEventListener('input',update));
      library.querySelector('[data-science-reset]').addEventListener('click',()=>{query.value=type.value=reg.value='';update();query.focus();});
      const route=()=>{const phase=root.location.hash.replace('#evidence-','');if([...type.options].some(option=>option.value===phase)){type.value=phase;update();}};
      root.addEventListener('hashchange',route);route();update();
    });
  }
  function initKnowledge(scope){
    scope.querySelectorAll('[data-knowledge-index]').forEach(index=>{
      if(index.dataset.initialized)return;
      index.dataset.initialized='true';
      const query=index.querySelector('[data-knowledge-query]'),kind=index.querySelector('[data-knowledge-kind]');
      const entries=[...index.querySelectorAll('[data-knowledge-entry]')];
      const update=()=>{let count=0;entries.forEach(entry=>{entry.hidden=!knowledgeMatches(entry.dataset,{query:query.value,kind:kind.value});if(!entry.hidden)count++;});index.querySelector('[data-knowledge-count]').textContent=String(count);index.querySelector('[data-knowledge-empty]').hidden=count!==0;};
      const reset=()=>{query.value=kind.value='';update();};
      [query,kind].forEach(input=>input.addEventListener('input',update));
      index.querySelector('[data-knowledge-reset]').addEventListener('click',()=>{reset();query.focus();});
      root.addEventListener('hashchange',()=>{if(root.location.hash.startsWith('#glossary-'))reset();});
      update();
    });
  }
  initKnowledge(root.document);
  root.document.addEventListener('shopify:section:load',event=>initKnowledge(event.target));
  root.document.querySelectorAll('a[hreflang]').forEach(link=>link.addEventListener('click',()=>{const target=new URL(link.href,root.location.href);target.hash=root.location.hash;link.href=target.href;}));
  root.document.querySelectorAll('form.storefront-localization').forEach(form=>form.addEventListener('submit',()=>{
    let input=form.querySelector('input[name="return_to"]');
    if(!input){input=root.document.createElement('input');input.type='hidden';input.name='return_to';form.appendChild(input);}
    input.value=root.location.pathname+root.location.search+root.location.hash;
  }));
  init(root.document);
  root.document.addEventListener('shopify:section:load',event=>init(event.target));
})(typeof window==='undefined'?globalThis:window);
